import { SvgIcon, SvgIconProps } from '@mui/material';

export default function WeatherOutlinedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 27" fill="none">
      <g fill="none">
        <path
          d="M10.7759 19.625L7.02588 23.5312"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7759 19.625L16.0259 23.5312"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2759 19.625L13.0259 21.9687"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.27588 19.625L4.02588 21.9687"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0259 10.2508C10.0258 10.512 10.0415 10.7729 10.0729 11.032C10.0415 10.7729 10.0258 10.512 10.0259 10.2508C10.0278 9.85834 10.0657 9.46699 10.1389 9.08203"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.026 16.5006C19.1946 16.5045 21.82 13.9412 22.021 10.6472C22.2221 7.35314 19.9295 4.46409 16.7859 4.04995C13.6423 3.63581 10.7315 5.83936 10.139 9.0818C8.75014 8.38828 7.09533 8.65116 5.96811 9.74439C4.84089 10.8376 4.47114 12.5382 5.03617 14.0307C5.60121 15.5232 6.9858 16.5031 8.52595 16.5006H16.026Z"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
